import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "001_initial",
  version: "1.0.0",
  sql: `
CREATE TABLE IF NOT EXISTS \`ai_agents\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`description\` text,
	\`system_prompt\` text DEFAULT '' NOT NULL,
	\`agent_type\` text DEFAULT 'standalone' NOT NULL,
	\`ai_provider\` text,
	\`ai_model\` text,
	\`api_key_source\` text DEFAULT 'tenant' NOT NULL,
	\`temperature\` real DEFAULT 0.7,
	\`max_steps\` integer DEFAULT 5,
	\`is_default\` integer DEFAULT 0,
	\`is_active\` integer DEFAULT 1,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`ai_agent_children\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`parent_agent_id\` text NOT NULL,
	\`child_agent_id\` text NOT NULL,
	\`routing_hint\` text,
	\`sort_order\` integer DEFAULT 0,
	\`is_enabled\` integer DEFAULT 1,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	FOREIGN KEY (\`parent_agent_id\`) REFERENCES \`ai_agents\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`child_agent_id\`) REFERENCES \`ai_agents\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE INDEX IF NOT EXISTS \`idx_ai_agent_children_parent\` ON \`ai_agent_children\` (\`parent_agent_id\`);
CREATE UNIQUE INDEX IF NOT EXISTS \`idx_ai_agent_children_unique\` ON \`ai_agent_children\` (\`parent_agent_id\`,\`child_agent_id\`);
CREATE TABLE IF NOT EXISTS \`ai_agent_tools\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`agent_id\` text NOT NULL,
	\`tool_name\` text NOT NULL,
	\`is_enabled\` integer DEFAULT 1,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	FOREIGN KEY (\`agent_id\`) REFERENCES \`ai_agents\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE UNIQUE INDEX IF NOT EXISTS \`idx_agent_tools_unique\` ON \`ai_agent_tools\` (\`agent_id\`,\`tool_name\`);
CREATE TABLE IF NOT EXISTS \`ai_knowledge_docs\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`title\` text NOT NULL,
	\`content\` text NOT NULL,
	\`category\` text,
	\`tags\` text,
	\`search_mode\` text DEFAULT 'keyword',
	\`is_active\` integer DEFAULT 1,
	\`is_vectorized\` integer DEFAULT 0,
	\`chunk_count\` integer DEFAULT 0,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text,
	\`deleted_at\` text,
	\`deleted_by\` text
);
CREATE TABLE IF NOT EXISTS \`ai_agent_knowledge\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`agent_id\` text NOT NULL,
	\`doc_id\` text NOT NULL,
	\`is_enabled\` integer DEFAULT 1,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	FOREIGN KEY (\`agent_id\`) REFERENCES \`ai_agents\`(\`id\`) ON UPDATE no action ON DELETE no action,
	FOREIGN KEY (\`doc_id\`) REFERENCES \`ai_knowledge_docs\`(\`id\`) ON UPDATE no action ON DELETE no action
);
CREATE UNIQUE INDEX IF NOT EXISTS \`idx_agent_knowledge_unique\` ON \`ai_agent_knowledge\` (\`agent_id\`,\`doc_id\`);
CREATE TABLE IF NOT EXISTS \`ai_knowledge_categories\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`company_id\` text NOT NULL,
	\`name\` text NOT NULL,
	\`color\` text,
	\`icon\` text,
	\`sort_order\` integer DEFAULT 0,
	\`is_active\` integer DEFAULT 1,
	\`created_at\` text NOT NULL,
	\`created_by\` text,
	\`updated_at\` text NOT NULL,
	\`updated_by\` text
);
CREATE TABLE IF NOT EXISTS \`ai_knowledge_chunks\` (
	\`id\` text PRIMARY KEY NOT NULL,
	\`doc_id\` text NOT NULL,
	\`chunk_index\` integer NOT NULL,
	\`content\` text NOT NULL,
	\`vector_id\` text,
	\`created_at\` text,
	FOREIGN KEY (\`doc_id\`) REFERENCES \`ai_knowledge_docs\`(\`id\`) ON UPDATE no action ON DELETE no action
);
  `.trim(),
};
